export default {
  animationEasing: 'quarticInOut',
  title: {
    text: '34534',
    subtext: '总持股数',
    textAlign: 'center',
    textStyle: {
      color: '#E63535',
      fontSize: 14,
    },
    subtextStyle: {
      color: '#262D40',
      fontSize: 11,
    },
    x: '30.5%',
    y: '37%',
  },
  legend: {
    show: false,
    data: ['机构持股', '内部持股', '其他', 'TOP10机构持股']
  },
  grid: {
    left: '0',
    right: '0',
    top: '0%',
    bottom: '0%',
  },
  series: [
    {
      name: '营入构成',
      type: 'pie',
      center: ['34%', '48%'],
      radius: ['52%', '73%'],
      avoidLabelOverlap: false,
      hoverAnimation: false,
      itemStyle: {
        borderWidth: 1.5,
        borderColor: '#fff',
      },
      label: {
        show: false,
        position: 'center',
        emphasis: {
          show: false,
          textStyle: {
            fontSize: '30',
            fontWeight: 'bold'
          }
        }
      },
      labelLine: {
        normal: {
          show: false
        }
      },
      data: []
    },
    {
      name: 'top10',
      type: 'pie',
      center: ['34%', '48%'],
      radius: ['81%', '82%'],
      avoidLabelOverlap: false,
      hoverAnimation: false,
      label: {
        show: false,
        position: 'center',
        emphasis: {
          show: false,
          textStyle: {
            fontSize: '30',
            fontWeight: 'bold'
          }
        }
      },
      labelLine: {
        normal: {
          show: false
        }
      },
      data: []
    }
  ]
}